export default __webpack_public_path__ + "static/media/zdobycie_poziomu.9c605c79.gif";